export function parseUrl() {
	return function(url) {
	    let parser = document.createElement('a');
	    parser.href = url;
	    return parser;
	}
}



// WEBPACK FOOTER //
// ./services/parse_url.js